import { createFileRoute } from '@tanstack/react-router';
import Credentials from '@piwikpro/user-panel/src/components/Credentials';

export const Route = createFileRoute('/_secured/profile/api-credentials')({
  component: Credentials,
});
